export default __webpack_public_path__ + "static/media/vines3.294ca372.png";